module.exports = __webpack_public_path__ + "static/img/showpic1.8413f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/showpic1.png
// module id = t0Wh
// module chunks = 37